import React from 'react';

import { Star } from 'lucide-react';

export function RatingStars({ value }: { value: number }) {
  return (
    <div className="flex items-center gap-[1px]">
      {Array.from({ length: value }).map((_, i) => (
        <Star key={i} className="h-[20px] w-[20px] fill-[#FBE34C] text-[#FBE34C]" />
      ))}
    </div>
  );
}
